import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const postCreateTag = (tagName) => {
  const url = `${baseUrl}/v1/entities/tags`;
  return apiService.post(url, { value: tagName });
};

const deleteTag = (assignmentId) => {
  const url = `${baseUrl}/v1/entities/tags/${assignmentId}`;
  return apiService.delete(url);
};

const patchEditTag = (assignmentId, tagName) => {
  const url = `${baseUrl}/v1/entities/tags/${assignmentId}`;
  return apiService.patch(url, { value: tagName });
};

export { postCreateTag, deleteTag, patchEditTag };
